<template>
<div class="container-fluid">

	<page-loading v-if="!data_loaded" />

	<template v-else>
		<div class="row">
		    <div class="col-12">
				<h1>Edit Report: {{ report.title }}</h1>
			</div>
		</div>

		<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
			<alert-errors :form="form">There were some problems with your input.</alert-errors>

			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header">Settings</div>
						<div class="card-body row">
							<div class="col-md-auto">
								<label class="mb-0">Thumbnail</label>
								<file-field
									ref="thumbnail"	
									:default_url="report.thumbnail_url"
									@file_changed="changedThumbnail($event)"
								/>
						    </div>
							<div class="col">				
							    <div class="form-group">
									<label class="mb-0">Title</label>
									<input class="form-control" v-model="form.title" required>
							    </div>
							    <div class="form-group">
									<label class="mb-0">Quicksight URL</label>
									<input class="form-control" v-model="form.dashboard_id" required>
							    </div>
							    
							    <div class="form-group">
								    <label class="mb-0">Height (with units: px or %) <span class="text-gray-500">- optional</span></label>
								    <input class="form-control" v-model="form.height">
							    </div>							    
							</div>
						</div>
					</div>
				</div>

				<div class="col-12">
					<div class="form-group">
						<span class="btn btn-ghost-secondary mr-1" @click="cancelEdit()">Cancel</span>
				    	<button type="submit" class="btn btn-primary">Save Report</button>
					</div>
				</div>
			</div>
		</form>	
	</template>
</div>
</template>

<script>
	import { mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata'

	export default {
        mixins: [BreadcrumbsManager],

        components: {
        	HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form
        },

		data() {
			return {
                report: null,
                data_loaded: false,
                form: {}
			}
		},

		created() {
			this.fetchReport();		
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Reports', to: { name: 'reports.index'} },
                { text: 'Edit Report', to: { name: 'reports.edit'} },
            ]); 	
        },

		methods: {
			cancelEdit() {
				this.$router.go(-1);
			},

			changedThumbnail($event) {
				this.form.thumbnail = this.$refs.thumbnail.file;
			},

            fetchReport() {
                axios.get('/api/reports/' + this.$route.params.id).then(({data}) => {
                    this.report = data;
                    this.data_loaded = true;
                    this.fillForm(data);
                });
            },

            fillForm(data) {
            	this.form = new Form({
					title: data.title,
					dashboard_id: data.dashboard_id,
					height: data.height,
					thumbnail: data.thumbnail,
				});
            },

        	submitForm() { 
				this.form.submit('post', '/api/reports/' + this.$route.params.id, {
					transformRequest: [function (data, headers) {
						data['_method'] = 'PUT';
						return objectToFormData(data)
					}],
				}).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Report saved',
					});						
					this.$router.push({ name: 'reports.index' });
				});     		
        	},
		},

		computed: {
			...mapState(['perms', 'user'])
		}
	}
</script>